import AppBar from "../../../components/atoms/appbar";

export default function PaymentHistory() {
  return (
    <div className="flex flex-col min-h-screen">
      <AppBar title="결제 내역" backButton />
      <div className="flex flex-col flex-1 justify-center items-center gap-[14px]">
        <img src="/icons/ic-notice.webp" />
        <p className="text-[14px] font-[500] text-[#ccc]">
          결제 내역이 없습니다.
        </p>
      </div>
    </div>
  );
}
